<script>
export default {
  functional: true,
  name: "InnerStartStop",
  render: function (h, {props, parent, children, listeners, ...args}) {
    const { name, stop, start ,showLabel} = props;
    const click = listeners.click;
    const $t = parent.$t;
    return (<div class={'sliderInput'}>
      {name && showLabel && <span class="scence_ctr_span_title">{ name }</span>}
      <div class={'sliderInput'}>
        {(stop ===undefined || start !== undefined)  && <button onClick={() => click(0)} class="warm_button warm_button_left statr_button"><i class="icon-141"></i>{$t('deviceMsg.stop')}</button>}
        {(start ===undefined || stop !== undefined)  && <button onClick={() => click(1)} class="warm_button statr_button"><i class="icon-10"></i>{$t('deviceMsg.start')}</button>}
      </div>
    </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";
.statr_button i {
  font-size: 20px;
  margin-right: 1px;
  float: left;
  margin-left: 2px;
  font-weight: normal;
  margin-top: 0px;
}
.warm_button{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
